export default async function GetExpense(data) {
    let url = window.RealestateService + "/api/Expense/GetExpense";
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response;
}